module.exports = __webpack_public_path__ + "img/dingding.21a7a85c.png";